module.exports = __webpack_public_path__ + "img/18_47.2e493048.png";